import { gift_16 as gift16 } from "@trustpilot/icons";
import { HtmlText, Text } from "ilenia";

import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import {
  StyledBodyContainer,
  StyledHeadingContainer,
  StyledInvertedIcon,
  StyledInvertedTypography,
  StyledLink,
  StyledTrialOuter,
  StyledTypography,
} from "../../styled";
import * as Types from "../../types/types";

const StartTrialInfo: React.FC<Types.StartTrialInfo> = ({ eligibility, setShowFreeTrialModal }) => {
  const analytics = useAnalytics();
  const localisationRoot = "Sidebar.startTrial";
  return (
    <StyledTrialOuter aria-labelledby="start-trial-heading">
      <StyledHeadingContainer>
        <StyledInvertedIcon content={gift16} height={20} width={18.75} />
        <StyledTypography variant="heading-xxs" as="h2" id="start-trial-heading">
          <Text id={`${localisationRoot}.heading`} />
        </StyledTypography>
      </StyledHeadingContainer>
      <StyledBodyContainer>
        <StyledInvertedTypography variant="body-s">
          <HtmlText id={`${localisationRoot}.body`} interpolations={{ duration: eligibility?.trial?.duration }} />
        </StyledInvertedTypography>
      </StyledBodyContainer>
      <StyledLink
        id="open-modal-button"
        as="button"
        onClick={() => {
          setShowFreeTrialModal(true);
          analytics.track(trackingConst.events.buttonClicked, {
            context: trackingConst.contexts.freeTrialModal,
            name: trackingConst.names.freeTrialOpened,
          });
        }}
      >
        <StyledInvertedTypography variant="body-s">
          <Text id={`${localisationRoot}.button`} />
        </StyledInvertedTypography>
      </StyledLink>
    </StyledTrialOuter>
  );
};
export default StartTrialInfo;
